import { Config } from './config';
const ABSOLUTE_URL_PATTERN = /^(?:[a-z][a-z\d+\-.]*:|\/\/)/i;
export function getUrl(url) {
    if (url.indexOf("data:") === 0) {
        return url;
    }
    const prefix = (() => {
        const cdnPrefix = Config.get("cdn_prefix");
        if (cdnPrefix) {
            return cdnPrefix.endsWith('/') ? cdnPrefix : cdnPrefix + '/';
        }
        const apiPrefix = Config.get("api_url");
        return apiPrefix.endsWith('/') ? apiPrefix : apiPrefix + '/';
    })();
    const suffix = Config.get("cdn_suffix");
    return prefix + url + suffix;
}
export function getAssetUrl(url) {
    if (ABSOLUTE_URL_PATTERN.test(url)) {
        return url;
    }
    const prefix = Config.get('assets_url');
    return prefix + url;
}
export function getApiUrl(url) {
    const prefix = (() => {
        const apiPrefix = Config.get("api_url");
        return apiPrefix.endsWith('/') ? apiPrefix : apiPrefix + '/';
    })();
    return prefix + url;
}
